import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import "select2"

export default class extends Controller {
  static targets = ["dropdown", "viewReport"]

  connect() {
    this.coursesLoaded = false
    if (!$(this.dropdownTarget).hasClass("select2-hidden-accessible")) {
      $(this.dropdownTarget).select2({
        dropdownParent: $('#selectCourseModal'),
        width: '100%',
        placeholder: "Select Course",
        data: [
          {
            id: '0',
            text: 'Loading courses...',
            selected: false,
            disabled: true
          }
        ]
      })
    }

    this.updateLink()
    $(this.dropdownTarget).on('change', this.updateLink.bind(this))
  }

  disconnect() {
    if ($(this.dropdownTarget).hasClass("select2-hidden-accessible")) {
      $(this.dropdownTarget).select2('destroy')
    }
  }

  loadCourses() {
    if (this.coursesLoaded) return;
    fetch("/report_dashboard/courses.json")
      .then(response => {
        if (!response.ok) throw new Error("Failed to load courses");
        return response.json();
      })
      .then(data => {
        this.dropdownTarget.innerHTML = '';

        if (Array.isArray(data) && data.length > 0) {
          // Add default option
          this.dropdownTarget.innerHTML = '<option value="">Select Course</option>';

          // Append courses
          data.forEach(course => {
            const option = document.createElement("option");
            option.value = course.id;
            option.textContent = course.name;
            option.setAttribute("data-name", course.name);
            this.dropdownTarget.appendChild(option);
          });

          this.initSelect2("Select Course");
        } else {
          const message = "No results found – create a course to view reports";

          // Add disabled option
          const option = document.createElement("option");
          option.value = "";
          option.textContent = message;
          option.disabled = true;
          option.selected = true;
          this.dropdownTarget.appendChild(option);

          this.initSelect2("Select Course", message);
        }

        this.coursesLoaded = true;
      })
      .catch(() => {
        this.dropdownTarget.innerHTML = '<option value="">Unable to load courses</option>';
        this.initSelect2("Unable to load courses");
        this.coursesLoaded = false;
      });
  }

  initSelect2(placeholder, noResultsMessage = null) {
    $(this.dropdownTarget).select2({
      dropdownParent: $('#selectCourseModal'),
      width: '100%',
      placeholder: placeholder,
      language: noResultsMessage
        ? { noResults: () => noResultsMessage }
        : {}
    });

    $(this.dropdownTarget).val("").trigger("change");
  }

  updateLink() {
    const dropdown = this.dropdownTarget
    const viewReport = this.viewReportTarget
    const selected = dropdown.options[dropdown.selectedIndex]
    const courseId = selected.value
    const urlTemplate = document.getElementById("course-report-url").value

    if (courseId) {
      const url = urlTemplate.replace('{course_id}', courseId)
      viewReport.href = url
      viewReport.onclick = (e) => {
        $('#selectCourseModal').modal('hide')
      }
      viewReport.classList.remove('disabled')
    } else {
      viewReport.href = "#"
      viewReport.onclick = function() { return false }
      viewReport.classList.add('disabled')
    }
  }
}
